export const modalInitialReducerState = {
  video: {},
  selectedPlaylists: [],
  playlistFormError: "",
  playlistName: "",
  showModal: false,
  showNewPlaylistForm: false,
  watchLater: false,
};
